import {useTrackingContext} from '@src/Providers/Tracking/TrackingContext';

/**
 * Primary public hook for all components. Returns the unified emit /
 * identify / trackRevenue / flush API plus the legacy `track` alias.
 *
 * Usage:
 *   const {emit} = useTracking();
 *   emit(TraceTokEvents.BookmarkAdded, {content_id, content_type});
 */
export const useTracking = () => {
  const {emit, track, identify, trackRevenue, flush, enabled} =
    useTrackingContext();
  return {emit, track, identify, trackRevenue, flush, enabled};
};

export default useTracking;
